import React, { ChangeEvent, useEffect, useState } from 'react'
import Typography from '@mui/material/Typography'
import {
    Autocomplete,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
    Paper,
    Switch,
    Tab,
    TextField,
} from '@mui/material'
import CancelIcon from '@mui/icons-material/Cancel'
import Cancel from './../../../../../../assets/icons/close.png'
import AutoCompleteMultiSelect from '../../../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx';
import TextAreaComponents from '../../../../../components/TextAreaComponents/TextAreaComponents.tsx';
import galleryIcon from './../../../../../../assets/icons/upload.png'
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import plusIcon from './../../../../../../assets/icons/plus.png'
import AddItemDialogComponent from '../../../AddItemDialog.tsx'
import AddSectionDialog from '../../../AddSectionDialog.tsx'
import AddMenuDialog from '../../../AddMenuDialog.tsx'
import itemImg from './../../../../../../assets/icons/discount.png'

import './AddDiscountDialog.css'
import TimingComponenet from '../../../../../components/TimingComponenet/TimingComponenet.tsx'
import { styled } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';
import SchedulerComponent from '../../../SchedulerView/ScheduleItemDialog/SchedulerComponent/SchedulerComponent.tsx'

const Root = styled('div')(({ theme }) => ({
    width: '100%',
    ...theme.typography.body2,
    '& > :not(style) + :not(style)': {
        marginTop: theme.spacing(2),
    },
}));

function AddDiscountDialog(props) {
    const [openDialog, setOpenDialog] = useState(false);
    const [openMenuDialog, setOpenMenuDialog] = useState(false)
    const [opneItemDialog, setOpenItemDialog] = useState(false)

    const TimingValue = (props) => {
        console.log("P: " + props);
    }

    const handleDialogOpen = (name) => {
        if (name == 'section') {
            setOpenDialog(true)
        }
        else if (name == 'menu') {
            setOpenMenuDialog(true)
        }
        else if (name == 'item') {
            setOpenItemDialog(true)
        }

    }
    const handleAddItem = (AddSectionData) => {
        setOpenDialog(AddSectionData)
        setOpenMenuDialog(AddSectionData)
        setOpenItemDialog(AddSectionData)
    }


    const handleClose = () => {
        props.onHandleAddItem(false)
    }
    const Menudata = [
        { id: 1, title: 'Section' },
        { id: 2, title: 'Item' },
        { id: 3, title: 'Menu' },
        // { id: 3, title: 'Buy x Get y free' },
        { id: 4, title: 'Combine' },
    ]
    const MenuTypedata = [
        { id: 1, title: 'In store menu' },
        { id: 2, title: 'Online' },
        { id: 3, title: 'Offers' },
        { id: 4, title: 'Chef special menu' },
    ]
    const Sectiondata = [
        { id: 1, title: 'Burger' },
        { id: 2, title: 'Chicken' },
        { id: 3, title: 'Pizza' },
    ]
    const itemdataTemp = [
        { id: 1, title: 'Burger (In-store)' },
        { id: 2, title: 'Burger (Online)' },
        { id: 3, title: 'Chicken (In-store)' },
        { id: 4, title: 'Chicken (Online)' },
        { id: 5, title: 'Pizza (In-store)' }
    ]
    const [percentageTypedata, setpercentageTypedata] = useState([
        { id: 1, title: 'Percentage' },
        { id: 2, title: 'Exact amount' }
    ]);
    const restaurantdata = [
        { id: 1, title: 'PKB london' },
        { id: 2, title: 'PKB london' }
    ]
    const [autoCompleteValue, setAutoCompleteValue] = React.useState()
    const [itemdata, setitemdata] = React.useState(itemdataTemp)
    const addValue = (props) => {
        console.log(props)
        setAutoCompleteValue(props)
    }
    const [logicdata, setlogicdata] = React.useState([
        { id: 1, title: 'Choose alternative' },
        { id: 2, title: 'Combine more' }
    ])
    const addlogicValue = (props) => {
        console.log(props)
        // setAutoCompleteValue(props)
    }
    const [typeValue, settypeValue] = React.useState()
    const addTypeValue = (props) => {
        console.log(props)
        settypeValue(props)
    }

    const [typeNeedToBuyValue, settypeNeedToBuyValue] = React.useState([])
    const addTypeNeedToBuyValue = (props) => {
        console.log(props);
        setnullvalue(props);
        settypeNeedToBuyValue(props);
    }
    const clickOnApplyOnCheapestItem = () => {
        if (!switchcheapestItem) {
            var tempValue = [
                { id: 1, title: 'Percentage' }
            ]
            setpercentageTypedata(tempValue)
        }
        else {
            var tempValue = [
                { id: 1, title: 'Percentage' },
                { id: 2, title: 'Exact amount' }
            ]
            setpercentageTypedata(tempValue)
        }
    }
    const [amountTypeValueset, setamountType] = React.useState()
    const amountTypeValue = (props) => {
        console.log(props)
        setamountType(props)
    }

    const [state, setState] = React.useState<ImageUploadState>({
        selectedImages: [],
    })

    const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files
        if (files) {
            const imagesArray: string[] = []
            const remainingSlots = 5 - state.selectedImages.length
            const filesToUpload = Array.from(files).slice(0, remainingSlots)
            for (let i = 0; i < filesToUpload.length; i++) {
                const file = filesToUpload[i]
                const reader = new FileReader()
                reader.onloadend = () => {
                    imagesArray.push(reader.result as string)
                    if (imagesArray.length === filesToUpload.length) {
                        const updatedImages = [...state.selectedImages, ...imagesArray]
                        setState({ selectedImages: updatedImages })
                    }
                }
                reader.readAsDataURL(file)
            }
        }
    }

    const handleDeleteImage = (index: number) => {
        const updatedImages = [...state.selectedImages]
        updatedImages.splice(index, 1)
        setState({ selectedImages: updatedImages })
    }
    const [selectDay, setSelectDay] = React.useState(true);
    const [mselectDay, setMSelectDay] = useState(true);
    const [TselectDay, setTSelectDay] = useState(true);
    const [WselectDay, setWSelectDay] = useState(true);
    const [T1selectDay, setT1SelectDay] = useState(true);
    const [FselectDay, setFSelectDay] = useState(true);
    const [SselectDay, setSSelectDay] = useState(true);

    // const [textFieldValue, settextFieldValues] = React.useState();

    const textFieldValue = (props) => {
        console.log("P: " + props);
    }

    const [radiovalue, setRadioValue] = React.useState('Specify');
    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRadioValue((event.target as HTMLInputElement).value);
        console.log("(event.target as HTMLInputElement).value: " + (event.target as HTMLInputElement).value);
        switch ((event.target as HTMLInputElement).value) {
            case "Item":
                setitemdata(itemdataTemp);
                break;
            case "Filter/ Sub filter":
                setitemdata(Sectiondata);
                break;
            case "Menu":
                setitemdata(MenuTypedata);
                break;
            case "All":
                setRadioValue((event.target as HTMLInputElement).value);
                break;
        }
        // setitemdata();
    };
    const [radioGetvalue, setradioGetvalue] = React.useState('Item');
    const handleradioGetvalueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setradioGetvalue((event.target as HTMLInputElement).value);
        console.log("(event.target as HTMLInputElement).value: " + (event.target as HTMLInputElement).value);
        switch ((event.target as HTMLInputElement).value) {
            case "Item":
                setitemdata(itemdataTemp);
                break;
            case "Filter/ Sub filter":
                setitemdata(Sectiondata);
                break;
            case "Menu":
                setitemdata(MenuTypedata);
                break;
            case "All":
                setradioGetvalue((event.target as HTMLInputElement).value);
                break;
        }
        // setitemdata();
    };

    const [radioLogicvalue, setradioLogicvalue] = React.useState('And');
    const handleradioLogicChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setradioLogicvalue((event.target as HTMLInputElement).value);

    };


    const [radioGetLogicvalue, setradioGetLogicvalue] = React.useState('And');
    const handleradioGetLogicvalueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setradioGetLogicvalue((event.target as HTMLInputElement).value);

    };

    const [open, setOpen] = React.useState(false)
    const handleClickOpen = () => {
        setOpen(true)
    }
    // const handleAddItem = (AddItemData) => {
    //     setOpen(AddItemData)
    // }
    const [switchCheck, setswitchCheck] = useState(false)
    const handleSwitchChange = () => {
        setswitchCheck(!switchCheck)
    }




    const [itemNeedToBuy, setitemNeedToBuy] = useState([]);
    const [tempitemNeedToBuy, settempitemNeedToBuy] = useState([]);
    const [nullvalue, setnullvalue] = useState([]);
    const handleAddEvent = () => {
        console.log("typeNeedToBuyValue: " + typeNeedToBuyValue);
        if (typeNeedToBuyValue != undefined || typeNeedToBuyValue.length > 0) {
            console.log("typeNeedToBuyValue222: " + typeNeedToBuyValue);
            settempitemNeedToBuy(itemNeedToBuy);
            for (let i = 0; i < typeNeedToBuyValue.length; i++) {
                var d = tempitemNeedToBuy.find(x => x.title === typeNeedToBuyValue[i].title);
                if (d === undefined) {
                    tempitemNeedToBuy.push(typeNeedToBuyValue[i])
                }

            }
            console.log("temData: " + tempitemNeedToBuy);
            // temData = typeNeedToBuyValue;
            setitemNeedToBuy([]);
            addTypeNeedToBuyValue([]);
            setnullvalue([]);
            console.log("itemNeedToBuy: " + itemNeedToBuy);

        }
    }
    useEffect(() => {
        setitemNeedToBuy(tempitemNeedToBuy);
    }, [itemNeedToBuy])
    const handleRemove = (props) => {
        console.log("props: " + props);

        settempitemNeedToBuy(itemNeedToBuy);
        var temp = itemNeedToBuy;
        var obj = temp.find(x => x.id === props);
        var index = temp.indexOf(obj);
        var j = temp.splice(index, 1);
        settempitemNeedToBuy(temp);
        setitemNeedToBuy([]);

        console.log("tempitemNeedToBuy: " + tempitemNeedToBuy);
        console.log("itemNeedToBuy: " + itemNeedToBuy);
    }
    const [switchBusketCheck, setswitchBusketCheck] = useState(false)
    const [switchComboCheck, setswitchComboCheck] = useState(false)
    const [switchGetBusketCheck, setswitchGetBusketCheck] = useState(false)
    const [switchcheapestItem, setswitchcheapestItem] = useState(false)
    const [switchQuantityCheck, setswitchQuantityCheck] = useState(false)
    const [switchGetQuantityCheck, setswitchGetQuantityCheck] = useState(false)
    return (
        <div>
            <React.Fragment>
                <Dialog
                    fullWidth={true}
                    maxWidth={'lg'}
                    open={props.open}
                    onClose={handleClose}
                >
                    <Grid container>
                        <Grid item xs={8}>
                            <DialogTitle>
                                <div className='d-flex' style={{ gap: "8px" }}>
                                    <div>
                                        <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
                                    </div>

                                    <span style={{ color: "#2a7fd4" }}>GoTaste :-   Add discounted item for Pot Kettle Black Manchester</span>
                                </div>


                            </DialogTitle>
                        </Grid>
                        <Grid item xs={4}>
                            <DialogActions>
                                <Button onClick={handleClose}>
                                    <img src={Cancel} alt="Close" style={{ width: '1.2rem' }} />
                                </Button>
                            </DialogActions>
                        </Grid>
                    </Grid>
                    <DialogContent style={{ backgroundColor: '#f3f0f3' }}>
                        <Grid container>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Select Restaurant
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Switch
                                    checked={switchCheck}
                                    onChange={handleSwitchChange}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />
                                Specific Restaurant
                            </Grid>

                        </Grid>
                        {
                            switchCheck ? (
                                <Grid container>
                                    <Grid item xs={2}>
                                        <Typography style={{ paddingTop: '1rem' }}>

                                        </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <AutoCompleteMultiSelect
                                            label={"Restaurant Name"}
                                            placeholder={'Restaurant Name'}
                                            value={addValue}
                                            datas={restaurantdata}
                                            id={1}
                                        />

                                    </Grid>

                                </Grid>
                            ) : ("")
                        }

                        <Grid container style={{ paddingTop: '1rem' }}>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Discount On
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <AutoCompleteMultiSelect
                                    label={"Discount On"}
                                    placeholder={'Discount On'}
                                    value={addValue}
                                    datas={Menudata}
                                    id={1}
                                />
                            </Grid>
                        </Grid>
                        <Grid container style={{ paddingTop: '1rem' }}>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Offer name
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <TextAreaComponents label={'Offer name'} value={textFieldValue} />
                            </Grid>
                        </Grid>
                        <Grid container style={{ paddingTop: '1rem' }}>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Offer details
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <TextAreaComponents label={'Offer details'} value={textFieldValue} />
                            </Grid>

                        </Grid>
                        {
                            autoCompleteValue === "Menu" ? (
                                <Grid container>
                                    <Grid item xs={2}>
                                        <Typography style={{ paddingTop: '1rem' }}>
                                            Menu
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={8} style={{ paddingTop: '1rem' }}>
                                        <AutoCompleteMultiSelect
                                            label={"Menu"}
                                            placeholder={'Menu'}
                                            value={addTypeValue}
                                            datas={MenuTypedata}
                                            id={1}
                                        />

                                    </Grid>

                                    <Grid item xs={2} className="AddItemplusIcon" onClick={() => handleDialogOpen('menu')}>
                                        {/* <img src={plusIcon} alt="+" onClick={() => handleDialogOpen('menu')} /> */}
                                        <button className='modalAddButton'>+Add Menu</button>

                                    </Grid>
                                    <Grid item xs={2}>
                                        <Typography style={{ paddingTop: '1rem' }}>
                                            Type of discount amount
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={8} style={{ paddingTop: '1rem' }}>
                                        <AutoCompleteMultiSelect
                                            label={"Type of discount amount"}
                                            placeholder={'Type of discount amount'}
                                            value={amountTypeValue}
                                            datas={percentageTypedata}
                                            id={1}
                                        />

                                    </Grid>
                                    <Grid item xs={2}></Grid>
                                    <Grid item xs={2}>
                                        <Typography style={{ paddingTop: '1rem' }}>
                                            Amount
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={8} style={{ paddingTop: '1rem' }}>
                                        <TextAreaComponents id={2} label={'Amount'} value={textFieldValue} />

                                    </Grid>
                                    <Grid container style={{ paddingTop: '1rem' }}>
                                        <Grid xs={2}>
                                            <Typography style={{ paddingTop: '1rem' }}>
                                                Poster Image
                                            </Typography>
                                        </Grid>
                                        <Grid xs={9}>
                                            <Button
                                                variant="contained"
                                                component="label"
                                                //   color="primary"
                                                className='uploadButton'
                                            // style={{ backgroundColor: 'white', color: 'gray' }}
                                            >
                                                <img
                                                    src={galleryIcon}
                                                    alt="photo"
                                                // style={{ width: '2rem' }}
                                                />
                                                Upload
                                                <input
                                                    hidden
                                                    accept="image/*"
                                                    multiple
                                                    type="file"
                                                    onChange={handleImageUpload}
                                                    disabled={state.selectedImages.length >= 5}
                                                />
                                            </Button>
                                        </Grid>

                                        {/* image show start */}
                                        <Grid container sx={{ padding: '0.5rem' }}>
                                            <Grid item xs={2}></Grid>
                                            <Grid item xs={9}>
                                                <Grid container spacing={2}>
                                                    {state.selectedImages.map((image, index) => (
                                                        <Grid item xs={2} sm={2} md={2} key={index}>
                                                            {/* <Paper> */}
                                                            <div
                                                                style={{
                                                                    position: 'relative',
                                                                    paddingTop: '20px',
                                                                }}
                                                            >
                                                                <img
                                                                    src={image}
                                                                    alt={`Preview ${index + 1}`}
                                                                    style={{
                                                                        maxWidth: '100%',
                                                                        maxHeight: '100%',
                                                                        objectFit: 'cover',
                                                                    }}
                                                                />
                                                                <IconButton
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: '-6px',
                                                                        right: '-23px',
                                                                        color: 'gray',
                                                                    }}
                                                                    onClick={() => handleDeleteImage(index)}
                                                                >
                                                                    <CancelIcon />
                                                                </IconButton>
                                                            </div>
                                                            {/* </Paper> */}
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {/* image show end */}
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Typography style={{ paddingTop: '1rem' }}>
                                            Timing
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={10}>
                                        <SchedulerComponent />

                                    </Grid>
                                    <Grid item xs={2}>
                                        <Typography style={{ paddingTop: '1rem' }}>
                                            Is Active
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                                        <Switch
                                            checked={switchCheck}
                                            onChange={() => { setswitchCheck(!switchCheck) }}
                                            inputProps={{ 'aria-label': 'controlled' }}
                                        />

                                    </Grid>
                                    <Grid container sx={{ padding: '0.5rem' }}>
                                        <Grid item xs={8}></Grid>
                                        <Grid item xs={2}>
                                            {/* <Button className="AddItemButtons">Preview</Button> */}
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Button className="">Save</Button>
                                        </Grid>
                                    </Grid>

                                </Grid>
                            ) : (autoCompleteValue === "Section" ? (
                                <Grid container>

                                    <Grid item xs={2}>
                                        <Typography style={{ paddingTop: '1rem' }}>
                                            Section
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={8} style={{ paddingTop: '1rem' }}>
                                        <AutoCompleteMultiSelect
                                            label={"Section"}
                                            placeholder={'Section'}
                                            value={addTypeValue}
                                            datas={Sectiondata}
                                            id={1}
                                        />

                                    </Grid>
                                    <Grid item xs={2} className="AddItemplusIcon" style={{ marginTop: '1rem' }} onClick={() => handleDialogOpen('section')}>
                                        {/* <img src={plusIcon} alt="+" onClick={() => handleDialogOpen('section')} /> */}
                                        <button className='modalAddButton'>+Add Section</button>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Typography style={{ paddingTop: '1rem' }}>
                                            Type of discount amount
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={8} style={{ paddingTop: '1rem' }}>
                                        <AutoCompleteMultiSelect
                                            label={"Type of discount amount"}
                                            placeholder={'Type of discount amount'}
                                            value={amountTypeValue}
                                            datas={percentageTypedata}
                                            id={1}
                                        />

                                    </Grid>
                                    <Grid item xs={2}></Grid>
                                    <Grid item xs={2}>
                                        <Typography style={{ paddingTop: '1rem' }}>
                                            Amount
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={8} style={{ paddingTop: '1rem' }}>
                                        <TextAreaComponents id={2} label={'Amount'} value={textFieldValue} />

                                    </Grid>
                                    <Grid item xs={2}></Grid>
                                    <Grid container style={{ paddingTop: '1rem' }}>
                                        <Grid xs={2}>
                                            <Typography style={{ paddingTop: '1rem' }}>
                                                Poster Image
                                            </Typography>
                                        </Grid>
                                        <Grid xs={9}>
                                            <Button
                                                variant="contained"
                                                component="label"
                                                //   color="primary"
                                                className='uploadButton'
                                            // style={{ backgroundColor: 'white', color: 'gray' }}
                                            >
                                                <img
                                                    src={galleryIcon}
                                                    alt="photo"
                                                // style={{ width: '2rem' }}
                                                />
                                                Upload
                                                <input
                                                    hidden
                                                    accept="image/*"
                                                    multiple
                                                    type="file"
                                                    onChange={handleImageUpload}
                                                    disabled={state.selectedImages.length >= 5}
                                                />
                                            </Button>
                                        </Grid>

                                        {/* image show start */}
                                        <Grid container sx={{ padding: '0.5rem' }}>
                                            <Grid item xs={2}></Grid>
                                            <Grid item xs={9}>
                                                <Grid container spacing={2}>
                                                    {state.selectedImages.map((image, index) => (
                                                        <Grid item xs={2} sm={2} md={2} key={index}>
                                                            {/* <Paper> */}
                                                            <div
                                                                style={{
                                                                    position: 'relative',
                                                                    paddingTop: '20px',
                                                                }}
                                                            >
                                                                <img
                                                                    src={image}
                                                                    alt={`Preview ${index + 1}`}
                                                                    style={{
                                                                        maxWidth: '100%',
                                                                        maxHeight: '100%',
                                                                        objectFit: 'cover',
                                                                    }}
                                                                />
                                                                <IconButton
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: '-6px',
                                                                        right: '-23px',
                                                                        color: 'gray',
                                                                    }}
                                                                    onClick={() => handleDeleteImage(index)}
                                                                >
                                                                    <CancelIcon />
                                                                </IconButton>
                                                            </div>
                                                            {/* </Paper> */}
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {/* image show end */}
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Typography style={{ paddingTop: '1rem' }}>
                                            Timing
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={10}>
                                        <SchedulerComponent />

                                    </Grid>
                                    <Grid item xs={2}>
                                        <Typography style={{ paddingTop: '1rem' }}>
                                            Is Active
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                                        <Switch
                                            checked={switchCheck}
                                            onChange={() => { setswitchCheck(!switchCheck) }}
                                            inputProps={{ 'aria-label': 'controlled' }}
                                        />

                                    </Grid>
                                    <Grid container sx={{ padding: '0.5rem' }}>
                                        <Grid item xs={8}></Grid>
                                        <Grid item xs={2}>
                                            {/* <Button className="AddItemButtons">Preview</Button> */}
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Button className="">Save</Button>
                                        </Grid>
                                    </Grid>

                                </Grid>
                            ) : (autoCompleteValue === "Item" ? (<Grid container>
                                <Grid item xs={2}>
                                    <Typography style={{ paddingTop: '1rem' }}>
                                        Item
                                    </Typography>
                                </Grid>
                                <Grid item xs={8} style={{ paddingTop: '1rem' }}>
                                    <AutoCompleteMultiSelect
                                        label={"Item"}
                                        placeholder={'Item'}
                                        value={addTypeValue}
                                        datas={itemdata}
                                        id={2}
                                    />

                                </Grid>
                                <Grid item xs={2} style={{ paddingTop: '1.5rem' }} className="AddItemplusIcon" onClick={handleClickOpen}>
                                    {/* <img src={plusIcon} alt="+" onClick={handleClickOpen} /> */}
                                    <button className='modalAddButton'>+Add Item</button>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography style={{ paddingTop: '1rem' }}>
                                        Type of discount amount
                                    </Typography>
                                </Grid>
                                <Grid item xs={8} style={{ paddingTop: '1rem' }}>
                                    <AutoCompleteMultiSelect
                                        label={"Type of discount amount"}
                                        placeholder={'Type of discount amount'}
                                        value={amountTypeValue}
                                        datas={percentageTypedata}
                                        id={1}
                                    />

                                </Grid>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={2}>
                                    <Typography style={{ paddingTop: '1rem' }}>
                                        Amount
                                    </Typography>
                                </Grid>
                                <Grid item xs={8} style={{ paddingTop: '1rem' }}>
                                    <TextAreaComponents id={2} label={'Amount'} value={textFieldValue} />

                                </Grid>
                                <Grid item xs={2}></Grid>
                                <Grid container style={{ paddingTop: '1rem' }}>
                                    <Grid xs={2}>
                                        <Typography style={{ paddingTop: '1rem' }}>
                                            Poster Image
                                        </Typography>
                                    </Grid>
                                    <Grid xs={9}>
                                        <Button
                                            variant="contained"
                                            component="label"
                                            //   color="primary"
                                            className='uploadButton'
                                        // style={{ backgroundColor: 'white', color: 'gray' }}
                                        >
                                            <img
                                                src={galleryIcon}
                                                alt="photo"
                                            // style={{ width: '2rem' }}
                                            />
                                            Upload
                                            <input
                                                hidden
                                                accept="image/*"
                                                multiple
                                                type="file"
                                                onChange={handleImageUpload}
                                                disabled={state.selectedImages.length >= 5}
                                            />
                                        </Button>
                                    </Grid>

                                    {/* image show start */}
                                    <Grid container sx={{ padding: '0.5rem' }}>
                                        <Grid item xs={2}></Grid>
                                        <Grid item xs={9}>
                                            <Grid container spacing={2}>
                                                {state.selectedImages.map((image, index) => (
                                                    <Grid item xs={2} sm={2} md={2} key={index}>
                                                        {/* <Paper> */}
                                                        <div
                                                            style={{
                                                                position: 'relative',
                                                                paddingTop: '20px',
                                                            }}
                                                        >
                                                            <img
                                                                src={image}
                                                                alt={`Preview ${index + 1}`}
                                                                style={{
                                                                    maxWidth: '100%',
                                                                    maxHeight: '100%',
                                                                    objectFit: 'cover',
                                                                }}
                                                            />
                                                            <IconButton
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: '-6px',
                                                                    right: '-23px',
                                                                    color: 'gray',
                                                                }}
                                                                onClick={() => handleDeleteImage(index)}
                                                            >
                                                                <CancelIcon />
                                                            </IconButton>
                                                        </div>
                                                        {/* </Paper> */}
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    {/* image show end */}
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography style={{ paddingTop: '1rem' }}>
                                        Timing
                                    </Typography>
                                </Grid>
                                <Grid item xs={10}>
                                    <SchedulerComponent />

                                </Grid>
                                <Grid item xs={2}>
                                    <Typography style={{ paddingTop: '1rem' }}>
                                        Is Active
                                    </Typography>
                                </Grid>
                                <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                                    <Switch
                                        checked={switchCheck}
                                        onChange={() => { setswitchCheck(!switchCheck) }}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                    />

                                </Grid>
                                <Grid container sx={{ padding: '0.5rem' }}>
                                    <Grid item xs={8}></Grid>
                                    <Grid item xs={2}>
                                        {/* <Button className="AddItemButtons">Preview</Button> */}
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Button className="">Save</Button>
                                    </Grid>
                                </Grid>

                            </Grid>) : (autoCompleteValue === "Combine" ? (
                                <>
                                    <div className='mt-3'>
                                        <Root>
                                            <Divider>
                                                <h4>Which Item Needs To Buy</h4>
                                            </Divider>
                                        </Root>
                                        {/* <div className='d-flex justify-content-center mt-3'>
                                            <h5>Which Item Needs To Buy</h5>
                                        </div> */}
                                        {/* <Grid container style={{ paddingTop: '1rem' }}>
                                            <Grid xs={2} >
                                                <Typography style={{ paddingTop: '1rem' }}>
                                                    Item Name
                                                </Typography>
                                            </Grid>
                                            <Grid xs={9}>
                                                <AutoCompleteMultiSelect
                                                    label={"Item"}
                                                    placeholder={'Item'}
                                                    value={addTypeValue}
                                                    datas={itemdata}
                                                    id={2}
                                                />
                                            </Grid>
                                        </Grid> */}
                                        <Grid container>
                                            <Grid item xs={2}>
                                                <Typography style={{ paddingTop: '1rem' }}>
                                                    Offer On Busket Value
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                                                <Switch
                                                    checked={switchBusketCheck}
                                                    onChange={() => { setswitchBusketCheck(!switchBusketCheck) }}
                                                    inputProps={{ 'aria-label': 'controlled' }}
                                                />

                                            </Grid>
                                        </Grid>
                                        {
                                            switchBusketCheck ? (
                                                <>

                                                    <Grid container>
                                                        <Grid xs={2} >
                                                            <Typography style={{ paddingTop: '1rem' }}>
                                                                Amount £
                                                            </Typography>
                                                        </Grid>
                                                        <Grid xs={9}>
                                                            <TextAreaComponents id={2} label={'Amount £'} value={textFieldValue} />
                                                        </Grid>
                                                    </Grid>

                                                </>
                                            ) : (
                                                <>
                                                    <Grid container>
                                                        <Grid item xs={2}>
                                                            <Typography style={{ paddingTop: '1rem' }}>
                                                                Combo
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                                                            <Switch
                                                                checked={switchComboCheck}
                                                                onChange={() => { setswitchComboCheck(!switchComboCheck) }}
                                                                inputProps={{ 'aria-label': 'controlled' }}
                                                            />

                                                        </Grid>
                                                    </Grid>
                                                    <Grid container style={{ paddingTop: '1rem' }}>
                                                        <Grid xs={2} >
                                                            <Typography style={{ paddingTop: '1rem' }}>
                                                                Apply on
                                                            </Typography>
                                                        </Grid>
                                                        <Grid xs={9}>
                                                            <RadioGroup
                                                                row
                                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                                name="row-radio-buttons-group"
                                                                value={radiovalue}
                                                                onChange={handleRadioChange}
                                                            >
                                                                <FormControlLabel value="Menu" control={<Radio />} label="Menu" />
                                                                <FormControlLabel value="Filter/ Sub filter" control={<Radio />} label="Filter/ Sub filter" />
                                                                <FormControlLabel value="Item" control={<Radio />} label="Item" />
                                                                {/* <FormControlLabel value="All" control={<Radio />} label="All" /> */}
                                                            </RadioGroup>
                                                        </Grid>
                                                    </Grid>
                                                    {radiovalue === "All" ? ("") : (
                                                        <>
                                                            <Grid container style={{ paddingTop: '1rem' }}>
                                                                <Grid xs={2} >
                                                                    <Typography style={{ paddingTop: '1rem' }}>
                                                                        Item Name
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid xs={9}>
                                                                    <AutoCompleteMultiSelect
                                                                        label={"Item"}
                                                                        placeholder={'Item'}
                                                                        value={addTypeNeedToBuyValue}
                                                                        datas={itemdata}
                                                                        id={2}
                                                                        val={nullvalue}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                            {/* <Grid container style={{ paddingTop: '1rem' }}>
                                                                <Grid xs={2} >
                                                                    <Typography style={{ paddingTop: '1rem' }}>
                                                                        Quantity
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid xs={9}>
                                                                    <Switch
                                                                        checked={switchQuantityCheck}
                                                                        onChange={() => { setswitchQuantityCheck(!switchQuantityCheck) }}
                                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                                    />
                                                                    {
                                                                        switchQuantityCheck ? ("Specify") : "Specify"
                                                                    }
                                                                    {switchQuantityCheck ? (
                                                                        <>
                                                                            <div className='d-flex justify-content-between align-items-center'>
                                                                                <div>
                                                                                    <span>Min</span>
                                                                                </div>
                                                                                <div style={{ width: "20rem" }}>
                                                                                    <TextAreaComponents id={2} label={'Min'} value={textFieldValue} />
                                                                                </div>
                                                                                <div>
                                                                                    <span>Max</span>
                                                                                </div>
                                                                                <div style={{ width: "20rem" }}>
                                                                                    <TextAreaComponents id={2} label={'Max'} value={textFieldValue} />
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    ) : ("")}

                                                                </Grid>
                                                            </Grid> */}
                                                            {/* <Grid container style={{ paddingTop: '1rem' }}>
                                                                <Grid xs={2} >
                                                                    <Typography style={{ paddingTop: '1rem' }}>
                                                                        Add On
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid xs={9}>
                                                                    <AutoCompleteMultiSelect
                                                                        label={"Add On"}
                                                                        placeholder={'Add On'}
                                                                        value={addTypeValue}
                                                                        datas={Sectiondata}
                                                                        id={2}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                            <Grid container style={{ paddingTop: '1rem' }}>
                                                                <Grid xs={2} >
                                                                    <Typography style={{ paddingTop: '1rem' }}>
                                                                        Add on Quantity
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid xs={9}>
                                                                    <TextAreaComponents id={2} label={'Add on Quantity'} value={textFieldValue} />
                                                                </Grid>
                                                            </Grid> */}
                                                            {/* <Grid container style={{ paddingTop: '1rem' }}>
                                                                <Grid xs={2}>
                                                                    <Typography>
                                                                        Logic
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid xs={9}>
                                                                    <RadioGroup
                                                                        row
                                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                                        name="row-radio-buttons-group"
                                                                        value={radioLogicvalue}
                                                                        onChange={handleradioLogicChange}
                                                                    >
                                                                        <FormControlLabel value="And" control={<Radio />} label="And" />
                                                                        <FormControlLabel value="OR" control={<Radio />} label="OR" />
                                                                        <FormControlLabel value="None" control={<Radio />} label="None" />
                                                                    </RadioGroup>
                                                                </Grid>
                                                            </Grid> */}

                                                            <Grid container style={{ paddingTop: '1rem' }}>
                                                                <Grid xs={2} >
                                                                    <Typography style={{ paddingTop: '1rem' }}>

                                                                    </Typography>
                                                                </Grid>
                                                                <Grid xs={9}>
                                                                    <div className='d-flex justify-content-end'>
                                                                        <button className='btn btn-success' onClick={() => { handleAddEvent() }}>Add</button>
                                                                    </div>
                                                                </Grid>
                                                            </Grid>
                                                            <table className='table'>
                                                                <thead className="thead-dark">
                                                                    <tr>
                                                                        <th>
                                                                            Logic
                                                                        </th>
                                                                        <th>
                                                                            Menu
                                                                        </th>
                                                                        {/* <th>
                                                                            Min
                                                                        </th>
                                                                        <th>
                                                                            Max
                                                                        </th> */}
                                                                        <th>
                                                                            Quantity need to buy
                                                                        </th>
                                                                        <th>
                                                                            Action
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        itemNeedToBuy.map((data, index) => {
                                                                            return (
                                                                                <tr>
                                                                                    <td>
                                                                                        {
                                                                                            index === 0 ? "None" : switchComboCheck ? "AND" : "OR"
                                                                                        }

                                                                                    </td>
                                                                                    <td>
                                                                                        {data.title}
                                                                                    </td>

                                                                                    <td>
                                                                                        <input type='number' className='form-control' placeholder='Quantity' />
                                                                                    </td>
                                                                                    <td>
                                                                                        <button className='btn btn-danger' onClick={() => { handleRemove(data.id) }}>Remove</button>
                                                                                    </td>
                                                                                </tr>
                                                                            )

                                                                        })
                                                                    }


                                                                </tbody>
                                                            </table>
                                                        </>
                                                    )}

                                                </>
                                            )
                                        }

                                    </div>
                                    <div className='mt-3'>
                                        <Root>
                                            <Divider>
                                                <h4>Discount Applied on</h4>
                                            </Divider>
                                        </Root>
                                        {/* <div className='d-flex justify-content-center mt-3'>
                                            <h5>Discounted Apply on</h5>
                                        </div> */}
                                        <Grid container>
                                            <Grid item xs={2}>
                                                <Typography style={{ paddingTop: '1rem' }}>
                                                    Discount on Busket Value
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                                                <Switch
                                                    checked={switchGetBusketCheck}
                                                    onChange={() => { setswitchGetBusketCheck(!switchGetBusketCheck) }}
                                                    inputProps={{ 'aria-label': 'controlled' }}
                                                />

                                            </Grid>
                                        </Grid>

                                        {
                                            switchGetBusketCheck ? (
                                                <>
                                                    <Grid container>
                                                        <Grid item xs={2}>
                                                            <Typography style={{ paddingTop: '1rem' }}>
                                                                Apply On Cheapest Item
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                                                            <Switch
                                                                checked={switchcheapestItem}
                                                                onChange={() => { setswitchcheapestItem(!switchcheapestItem); clickOnApplyOnCheapestItem() }}
                                                                inputProps={{ 'aria-label': 'controlled' }}
                                                            />

                                                        </Grid>
                                                    </Grid>
                                                    <Grid container style={{ paddingTop: '1rem' }}>
                                                        <Grid item xs={2}>
                                                            <Typography style={{ paddingTop: '1rem' }}>
                                                                Discount Apply By
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                                                            <AutoCompleteMultiSelect
                                                                label={"E.g. Percentage / Amount"}
                                                                placeholder={'E.g. Percentage / Amount'}
                                                                value={amountTypeValue}
                                                                datas={percentageTypedata}
                                                                id={1}
                                                            />

                                                        </Grid>
                                                    </Grid>
                                                    <Grid container style={{ paddingTop: '1rem' }}>
                                                        <Grid xs={2} >
                                                            <Typography style={{ paddingTop: '1rem' }}>
                                                                Amount
                                                            </Typography>
                                                        </Grid>
                                                        <Grid xs={9}>
                                                            <TextAreaComponents id={2} label={'Amount'} value={textFieldValue} />
                                                        </Grid>
                                                    </Grid>
                                                    {/* <Grid container style={{ paddingTop: '1rem' }}>
                                                        <Grid xs={2} >
                                                            <Typography style={{ paddingTop: '1rem' }}>
                                                                Amount £
                                                            </Typography>
                                                        </Grid>
                                                        <Grid xs={9}>
                                                            <TextAreaComponents id={2} label={'Amount £'} value={textFieldValue} />
                                                        </Grid>
                                                    </Grid> */}
                                                </>
                                            ) : (
                                                <>
                                                    <Grid container style={{ paddingTop: '1rem' }}>
                                                        <Grid xs={2} >
                                                            <Typography style={{ paddingTop: '1rem' }}>
                                                                Apply on
                                                            </Typography>
                                                        </Grid>
                                                        <Grid xs={9}>
                                                            <RadioGroup
                                                                row
                                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                                name="row-radio-buttons-group"
                                                                value={radioGetvalue}
                                                                onChange={handleradioGetvalueChange}
                                                            >
                                                                <FormControlLabel value="Menu" control={<Radio />} label="Menu" />
                                                                <FormControlLabel value="Filter/ Sub filter" control={<Radio />} label="Filter/ Sub filter" />
                                                                <FormControlLabel value="Item" control={<Radio />} label="Item" />
                                                                {/* <FormControlLabel value="All" control={<Radio />} label="All" /> */}
                                                            </RadioGroup>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid container style={{ paddingTop: '1rem' }}>
                                                        <Grid xs={2} >
                                                            <Typography style={{ paddingTop: '1rem' }}>
                                                                Item Name
                                                            </Typography>
                                                        </Grid>
                                                        <Grid xs={4}>
                                                            <AutoCompleteMultiSelect
                                                                label={"Item"}
                                                                placeholder={'Item'}
                                                                value={addTypeValue}
                                                                datas={itemdata}
                                                                id={2}
                                                            />
                                                        </Grid>
                                                        <Grid xs={2}>
                                                            <div className='d-flex justify-content-end w-100 align-items-center' style={{ height: "100%" }}>
                                                                <button className='btn btn-success w-100 ' style={{ height: "100%" }}>Choose</button>
                                                            </div>
                                                        </Grid>
                                                        <Grid xs={4}>
                                                            <AutoCompleteMultiSelect
                                                                label={"Combine more / choose alternative"}
                                                                placeholder={'Logic'}
                                                                value={addlogicValue}
                                                                datas={logicdata}
                                                                id={1}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    {/* <Grid container style={{ paddingTop: '1rem' }}>
                                                        <Grid xs={2} >
                                                            <Typography style={{ paddingTop: '1rem' }}>
                                                                Quantity
                                                            </Typography>
                                                        </Grid>
                                                        <Grid xs={9}>
                                                            <Switch
                                                                checked={switchGetQuantityCheck}
                                                                onChange={() => { setswitchGetQuantityCheck(!switchGetQuantityCheck) }}
                                                                inputProps={{ 'aria-label': 'controlled' }}
                                                            />
                                                            {
                                                                switchGetQuantityCheck ? ("Specify") : "Specify"
                                                            }
                                                            {switchGetQuantityCheck ? (
                                                                <>
                                                                    <div className='d-flex justify-content-between align-items-center'>
                                                                        <div>
                                                                            <span>Min</span>
                                                                        </div>
                                                                        <div style={{ width: "20rem" }}>
                                                                            <TextAreaComponents id={2} label={'Min'} value={textFieldValue} />
                                                                        </div>
                                                                        <div>
                                                                            <span>Max</span>
                                                                        </div>
                                                                        <div style={{ width: "20rem" }}>
                                                                            <TextAreaComponents id={2} label={'Max'} value={textFieldValue} />
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            ) : ("")}

                                                        </Grid>
                                                    </Grid> */}
                                                    {/* <Grid container style={{ paddingTop: '1rem' }}>
                                                        <Grid xs={2} >
                                                            <Typography style={{ paddingTop: '1rem' }}>
                                                                Is Free
                                                            </Typography>
                                                        </Grid>
                                                        <Grid xs={9}>
                                                            <Switch
                                                                checked={switchCheck}
                                                                onChange={() => { setswitchCheck(!switchCheck) }}
                                                                inputProps={{ 'aria-label': 'controlled' }}
                                                            />
                                                           
                                                        </Grid>
                                                    </Grid> */}
                                                    {/* <Grid container style={{ paddingTop: '1rem' }}>
                                                        <Grid item xs={2}>
                                                            <Typography style={{ paddingTop: '1rem' }}>
                                                                Type of discount amount
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                                                            <AutoCompleteMultiSelect
                                                                label={"Type of discount amount"}
                                                                placeholder={'Type of discount amount'}
                                                                value={amountTypeValue}
                                                                datas={percentageTypedata}
                                                                id={1}
                                                            />

                                                        </Grid>
                                                    </Grid>
                                                    <Grid container style={{ paddingTop: '1rem' }}>
                                                        <Grid xs={2} >
                                                            <Typography style={{ paddingTop: '1rem' }}>
                                                                Amount
                                                            </Typography>
                                                        </Grid>
                                                        <Grid xs={9}>
                                                            <TextAreaComponents id={2} label={'Amount'} value={textFieldValue} />
                                                        </Grid>
                                                    </Grid> */}
                                                    {/* <Grid container style={{ paddingTop: '1rem' }}>
                                                        <Grid xs={2}>
                                                            <Typography>
                                                                Logic
                                                            </Typography>
                                                        </Grid>
                                                        <Grid xs={9}>
                                                            <RadioGroup
                                                                row
                                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                                name="row-radio-buttons-group"
                                                                value={radioGetLogicvalue}
                                                                onChange={handleradioGetLogicvalueChange}
                                                            >
                                                                <FormControlLabel value="And" control={<Radio />} label="Combine more" />
                                                                <FormControlLabel value="OR" control={<Radio />} label="Choose alternative" />
                                                                <FormControlLabel value="None" control={<Radio />} label="None" />
                                                            </RadioGroup>
                                                        </Grid>
                                                    </Grid> */}
                                                    {/* <Grid container style={{ paddingTop: '1rem' }}>
                                                        <Grid xs={2} >
                                                            <Typography style={{ paddingTop: '1rem' }}>

                                                            </Typography>
                                                        </Grid>
                                                        <Grid xs={9}>
                                                            <div className='d-flex justify-content-end'>
                                                                <button className='btn btn-success'>Add</button>
                                                            </div>
                                                        </Grid>
                                                    </Grid> */}
                                                    <table className='table'>
                                                        <thead className="thead-dark">
                                                            <tr>
                                                                <th>
                                                                    Logic
                                                                </th>
                                                                <th>
                                                                    Menu
                                                                </th>
                                                                {/* <th>
                                                                    Min
                                                                </th>
                                                                <th>
                                                                    Max
                                                                </th> */}
                                                                <th>
                                                                    Quantity
                                                                </th>
                                                                <th>
                                                                    Type of discount amount
                                                                </th>
                                                                <th>
                                                                    Amount
                                                                </th>
                                                                <th>
                                                                    Action
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    None
                                                                </td>
                                                                <td>
                                                                    burger
                                                                </td>
                                                                {/* <td>
                                                                    1
                                                                </td>
                                                                <td>
                                                                    1
                                                                </td> */}
                                                                <td>
                                                                    <TextAreaComponents id={2} label={'Quantity'} value={textFieldValue} />
                                                                </td>
                                                                <td>
                                                                    <AutoCompleteMultiSelect
                                                                        label={"Type of discount amount"}
                                                                        placeholder={'Type of discount amount'}
                                                                        value={amountTypeValue}
                                                                        datas={percentageTypedata}
                                                                        id={1}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <TextAreaComponents id={2} label={'Amount'} value={textFieldValue} />
                                                                </td>
                                                                <td>
                                                                    <button className='btn btn-danger'>Remove</button>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    And
                                                                </td>
                                                                <td>
                                                                    In-store menu
                                                                </td>
                                                                {/* <td>
                                                                    1
                                                                </td>
                                                                <td>
                                                                    1
                                                                </td> */}
                                                                <td>
                                                                    <TextAreaComponents id={2} label={'Quantity'} value={textFieldValue} />
                                                                </td>
                                                                <td>
                                                                    <AutoCompleteMultiSelect
                                                                        label={"Type of discount amount"}
                                                                        placeholder={'Type of discount amount'}
                                                                        value={amountTypeValue}
                                                                        datas={percentageTypedata}
                                                                        id={1}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <TextAreaComponents id={2} label={'Amount'} value={textFieldValue} />
                                                                </td>
                                                                <td>
                                                                    <button className='btn btn-danger'>Remove</button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </>
                                            )
                                        }

                                    </div>
                                    <div className='mt-3'>
                                        <Root>
                                            <Divider>
                                                <h4>Schedule</h4>
                                            </Divider>
                                        </Root>
                                    </div>

                                    <Grid container style={{ paddingTop: '1rem' }}>
                                        {/* <Grid xs={2} >
                                            <Typography style={{ paddingTop: '1rem' }}>
                                                Timing
                                            </Typography>
                                        </Grid> */}
                                        <Grid xs={12}>
                                            <SchedulerComponent from="discount" />
                                        </Grid>
                                    </Grid>
                                    <Grid container style={{ paddingTop: '1rem' }}>
                                        <Grid xs={2}>
                                            <Typography style={{ paddingTop: '1rem' }}>
                                                Poster Image
                                            </Typography>
                                        </Grid>
                                        <Grid xs={9}>
                                            <Button
                                                variant="contained"
                                                component="label"
                                                //   color="primary"
                                                className='uploadButton'
                                            // style={{ backgroundColor: 'white', color: 'gray' }}
                                            >
                                                <img
                                                    src={galleryIcon}
                                                    alt="photo"
                                                // style={{ width: '2rem' }}
                                                />
                                                Upload
                                                <input
                                                    hidden
                                                    accept="image/*"
                                                    multiple
                                                    type="file"
                                                    onChange={handleImageUpload}
                                                    disabled={state.selectedImages.length >= 5}
                                                />
                                            </Button>
                                        </Grid>

                                        {/* image show start */}
                                        <Grid container sx={{ padding: '0.5rem' }}>
                                            <Grid item xs={2}></Grid>
                                            <Grid item xs={9}>
                                                <Grid container spacing={2}>
                                                    {state.selectedImages.map((image, index) => (
                                                        <Grid item xs={2} sm={2} md={2} key={index}>
                                                            {/* <Paper> */}
                                                            <div
                                                                style={{
                                                                    position: 'relative',
                                                                    paddingTop: '20px',
                                                                }}
                                                            >
                                                                <img
                                                                    src={image}
                                                                    alt={`Preview ${index + 1}`}
                                                                    style={{
                                                                        maxWidth: '100%',
                                                                        maxHeight: '100%',
                                                                        objectFit: 'cover',
                                                                    }}
                                                                />
                                                                <IconButton
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: '-6px',
                                                                        right: '-23px',
                                                                        color: 'gray',
                                                                    }}
                                                                    onClick={() => handleDeleteImage(index)}
                                                                >
                                                                    <CancelIcon />
                                                                </IconButton>
                                                            </div>
                                                            {/* </Paper> */}
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {/* image show end */}
                                    </Grid>
                                    {/* <Grid container style={{ paddingTop: '1rem' }}>
                                        <Grid xs={2} >
                                            <Typography style={{ paddingTop: '1rem' }}>

                                            </Typography>
                                        </Grid>
                                        <Grid xs={9}>
                                            <div className='d-flex justify-content-end'>
                                                <button className='btn btn-success'>Add</button>
                                            </div>
                                        </Grid>
                                    </Grid> */}

                                </>



                            ) : autoCompleteValue === "Buy x Get y free" ? (
                                <Grid container>
                                    <Grid container style={{ paddingTop: '1rem' }}>
                                        <Grid xs={2} >
                                            <Typography style={{ paddingTop: '1rem' }}>

                                            </Typography>
                                        </Grid>
                                        <Grid xs={9}>
                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                                value={radiovalue}
                                                onChange={handleRadioChange}
                                            >
                                                <FormControlLabel value="Menu" control={<Radio />} label="Menu" />
                                                <FormControlLabel value="Filter/ Sub filter" control={<Radio />} label="Filter/ Sub filter" />
                                                <FormControlLabel value="Item" control={<Radio />} label="Item" />
                                            </RadioGroup>
                                        </Grid>
                                    </Grid>

                                    <Grid container style={{ paddingTop: '1rem' }}>
                                        <Grid xs={2} >
                                            <Typography style={{ paddingTop: '1rem' }}>
                                                Item Name
                                            </Typography>
                                        </Grid>
                                        <Grid xs={9}>
                                            <AutoCompleteMultiSelect
                                                label={"Item"}
                                                placeholder={'Item'}
                                                value={addTypeValue}
                                                datas={itemdata}
                                                id={2}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container style={{ paddingTop: '1rem' }}>
                                        <Grid xs={2} >
                                            <Typography style={{ paddingTop: '1rem' }}>

                                            </Typography>
                                        </Grid>
                                        <Grid xs={9}>
                                            <div className='d-flex justify-content-end'>
                                                <button className='btn btn-success'>Add</button>
                                            </div>
                                        </Grid>
                                    </Grid>
                                    <Grid container style={{ paddingTop: '1rem' }}>
                                        <Grid xs={2} >
                                            <Typography style={{ paddingTop: '1rem' }}>

                                            </Typography>
                                        </Grid>
                                        <Grid xs={9}>
                                            <table className='table'>
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            Name
                                                        </th>
                                                        <th>
                                                            Quantity
                                                        </th>
                                                        <th>
                                                            Restaurant Name
                                                        </th>
                                                        <th>
                                                            Type
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            Burger
                                                        </td>
                                                        <td>
                                                            5
                                                        </td>
                                                        <td>
                                                            Pkb london
                                                        </td>
                                                        <td>
                                                            Item
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            Chicken
                                                        </td>
                                                        <td>
                                                            5
                                                        </td>
                                                        <td>
                                                            Pkb london
                                                        </td>
                                                        <td>
                                                            Section
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            In-store menu
                                                        </td>
                                                        <td>
                                                            5
                                                        </td>
                                                        <td>
                                                            Pkb london
                                                        </td>
                                                        <td>
                                                            Menu
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Typography style={{ paddingTop: '1rem' }}>
                                            Type of discount amount
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={8} style={{ paddingTop: '1rem' }}>
                                        <AutoCompleteMultiSelect
                                            label={"Type of discount amount"}
                                            placeholder={'Type of discount amount'}
                                            value={amountTypeValue}
                                            datas={percentageTypedata}
                                            id={1}
                                        />

                                    </Grid>
                                    <Grid item xs={2}></Grid>
                                    <Grid item xs={2}>
                                        <Typography style={{ paddingTop: '1rem' }}>
                                            Amount
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={8} style={{ paddingTop: '1rem' }}>
                                        <TextAreaComponents id={2} label={'Amount'} value={textFieldValue} />

                                    </Grid>
                                    <Grid container style={{ paddingTop: '1rem' }}>
                                        <Grid xs={2}>
                                            <Typography style={{ paddingTop: '1rem' }}>
                                                Poster Image
                                            </Typography>
                                        </Grid>
                                        <Grid xs={9}>
                                            <Button
                                                variant="contained"
                                                component="label"
                                                //   color="primary"
                                                className='uploadButton'
                                            // style={{ backgroundColor: 'white', color: 'gray' }}
                                            >
                                                <img
                                                    src={galleryIcon}
                                                    alt="photo"
                                                // style={{ width: '2rem' }}
                                                />
                                                Upload
                                                <input
                                                    hidden
                                                    accept="image/*"
                                                    multiple
                                                    type="file"
                                                    onChange={handleImageUpload}
                                                    disabled={state.selectedImages.length >= 5}
                                                />
                                            </Button>
                                        </Grid>

                                        {/* image show start */}
                                        <Grid container sx={{ padding: '0.5rem' }}>
                                            <Grid item xs={2}></Grid>
                                            <Grid item xs={9}>
                                                <Grid container spacing={2}>
                                                    {state.selectedImages.map((image, index) => (
                                                        <Grid item xs={2} sm={2} md={2} key={index}>
                                                            {/* <Paper> */}
                                                            <div
                                                                style={{
                                                                    position: 'relative',
                                                                    paddingTop: '20px',
                                                                }}
                                                            >
                                                                <img
                                                                    src={image}
                                                                    alt={`Preview ${index + 1}`}
                                                                    style={{
                                                                        maxWidth: '100%',
                                                                        maxHeight: '100%',
                                                                        objectFit: 'cover',
                                                                    }}
                                                                />
                                                                <IconButton
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: '-6px',
                                                                        right: '-23px',
                                                                        color: 'gray',
                                                                    }}
                                                                    onClick={() => handleDeleteImage(index)}
                                                                >
                                                                    <CancelIcon />
                                                                </IconButton>
                                                            </div>
                                                            {/* </Paper> */}
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {/* image show end */}
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Typography style={{ paddingTop: '1rem' }}>
                                            Timing
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={10}>
                                        <SchedulerComponent />

                                    </Grid>
                                    <Grid item xs={2}>
                                        <Typography style={{ paddingTop: '1rem' }}>
                                            Is Active
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                                        <Switch
                                            checked={switchCheck}
                                            onChange={() => { setswitchCheck(!switchCheck) }}
                                            inputProps={{ 'aria-label': 'controlled' }}
                                        />

                                    </Grid>
                                    <Grid container sx={{ padding: '0.5rem' }}>
                                        <Grid item xs={8}></Grid>
                                        <Grid item xs={2}>
                                            {/* <Button className="AddItemButtons">Preview</Button> */}
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Button className="">Save</Button>
                                        </Grid>
                                    </Grid>

                                </Grid>
                            ) : "")))
                        }
                        <div className='d-flex justify-content-end'>
                            <Button>Save</Button>
                        </div>

                    </DialogContent>
                    {/* <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions> */}
                </Dialog>
            </React.Fragment>
            <AddItemDialogComponent
                open={open}
                onHandleAddItem={handleAddItem}
                title={props.title}
            />
            <AddSectionDialog open={openDialog}
                dialogType={'Add Section'} onHandleAddItem={handleAddItem} />
            <AddMenuDialog open={openMenuDialog}
                dialogType={'Add Menu'} onHandleAddItem={handleAddItem} />

        </div>
    );
}

export default AddDiscountDialog;